export const en = {
  locale: 'en',
  people: 'People',
  favorites: 'Favourites',
  scheduler: 'Scheduler',
  new_group: 'New Group',
  settings: 'Settings',
  close: 'Close',
  log_out: 'Log out',
  calendar: 'Calendar',
  card: 'Card',
  favorites_add: 'Add to favorites',
  favorites_remove: 'Remove from favorites',
  group_add: 'Add to group',
  mobile: 'Mobile',
  email: 'Email',
  title: 'Title',
  city: 'City',
  department: 'Department',
  start: 'Start',
  end: 'End',
  location: 'Location',
  chair: 'Chair',
  required: 'Required',
  optional: 'Optional',
  month: 'Month',
  week: 'Week',
  day: 'Day',
  search: 'Search',
  select_city: 'Filter by city',
  select_department: 'Filter by department',
  select_location: 'Filter by location',
  select_company: 'Filter by company',
  filter_events: 'Filter events',
  all: 'All',
  vacation: 'Vacation',
  time: 'Time',
  notes: 'Notes',
  send: 'Send',
  create_new_event: 'Create new event',
  todays_meetings: "Today's meetings",
  room: 'Room',
  no_upcoming_events: 'No upcoming events',
  no_events: 'No events',
  all_day_event: 'All day',
  meeting_rooms: 'Meeting rooms',
  other_resources: 'Other resources',
  end_meeting: 'End meeting',
  available: 'Available',
  next_meeting_starts: 'Next meeting starts',
  book_now: 'Book now',
  book: 'Book',
  name: 'Name',
  send_booking: 'Book',
  min: 'min',
  hour: 'hour',
  hours: 'hours',
  date_range: 'Select a date range',
  change_all: 'Save selected as',
  contact: 'Contact',
  meeting_room: 'Meeting room',
  other_resource: 'Other resource',
  units_chosen: 'resources chosen',
  clear_list: 'Clear list',
  classification_success: 'Your changes have been saved',
  classification_failure: 'Something went wrong. Please try again',
  today: 'Today',
  resources: 'Resources',
  all_day: 'all-day',
  signup_ready: 'Account creation completed',
  signup_pending: 'We are creating your account',
  signup_pending_instructions: 'Please do not close this page',
  login: 'Login',
};
export const nb = {
  locale: 'nb',
  people: 'Personer',
  favorites: 'Favoritter',
  scheduler: 'Timeplan',
  new_group: 'Ny gruppe',
  settings: 'Innstillinger',
  close: 'Lukk',
  log_out: 'Logg ut',
  calendar: 'Kalender',
  card: 'Kort',
  favorites_add: 'Legg til i favoritter',
  favorites_remove: 'Fjern fra favoritter',
  group_add: 'Legg til i gruppe',
  mobile: 'Mobil',
  email: 'E-post',
  title: 'Tittel',
  city: 'By',
  department: 'Avdeling',
  start: 'Start',
  end: 'Slutt',
  location: 'Sted',
  chair: 'Møteleder',
  required: 'Obligatorisk',
  optional: 'Valgfri',
  month: 'Måned',
  week: 'Uke',
  day: 'Dag',
  search: 'Søk',
  select_city: 'Filtrer by',
  select_department: 'Filtrer avdeling',
  select_location: 'Filtrer etter sted',
  select_company: 'Filtrer etter selskap',
  filter_events: 'Filtrer aktiviter',
  all: 'Alle',
  vacation: 'Ferie',
  time: 'Tid',
  notes: 'Detaljer',
  send: 'Send',
  create_new_event: 'Ny aktivitet',
  todays_meetings: 'Dagens møter',
  room: 'Rom',
  no_upcoming_events: 'Ingen kommende avtaler',
  no_events: 'Ingen avtaler',
  all_day_event: 'Hele dagen',
  meeting_rooms: 'Møterom',
  other_resources: 'Andre ressurser',
  end_meeting: 'Avslutt møte',
  available: 'Ledig',
  next_meeting_starts: 'Neste møte',
  book_now: 'Reserver nå',
  book: 'Reserver',
  name: 'Navn',
  send_booking: 'Send reservasjon',
  min: 'min',
  hour: 'time',
  hours: 'timer',
  date_range: 'Velg tidsrom',
  change_all: 'Lag valgte som',
  other_resource: 'Annen ressurs',
  contact: 'Kontakt',
  meeting_room: 'Møterom',
  units_chosen: 'ressurser valgt',
  clear_list: 'Tøm liste',
  classification_success: 'Endringene dine er lagret',
  classification_failure: 'Noe gikk galt. Vennligst prøv igjen.',
  today: 'I dag',
  resources: 'Ressurser',
  all_day: 'Hele dagen',
  signup_ready: 'Kontoen er opprettet',
  signup_pending: 'Kontoen blir opprettet',
  signup_pending_instructions: 'Vennligst ikke lukk denne siden',
  login: 'Logg Inn',
};



// WEBPACK FOOTER //
// ./src/js/Components/Language.js